import { useEffect } from "react";
import { useSelector } from "react-redux";

const UploadOverlay = () => {
  const { loading, progress, current, total } = useSelector((state) => state.upload);

  console.log("Overlay Rendered", { loading, progress, current, total });

  useEffect(() => { 
    console.log(progress)
  }, [progress])

  if (!loading) return null;
  
  return (
    <div className="fixed inset-0 z-[9999999999999999999] flex items-center justify-center bg-zinc-900/50 backdrop-blur-md transition-all duration-300">
      <div className="bg-white rounded-3xl shadow-[0_25px_50px_-12px_rgba(0,0,0,0.25)] p-8 w-[360px] text-center border border-zinc-100 flex flex-col items-center gap-4">
        
        {/* Spinner */}
        <div className="relative w-16 h-16">
          {/* Background Ring */}
          <div className="absolute inset-0 w-full h-full border-4 border-zinc-100 rounded-full"></div>
          {/* Animated Ring */}
          <div className="absolute inset-0 w-full h-full border-4 border-transparent border-t-sky-500 rounded-full animate-spin"></div>
        </div>

        {/* Content */}
        <div className="flex flex-col gap-1">
          <h2 className="text-xl font-bold text-zinc-900">
            Uploading Images...
          </h2>
          <p className="text-zinc-500 text-sm font-medium">
            Uploading {current || 1} of {total || 1}
          </p>
        </div>

        {/* Progress % */}
        <div className="flex flex-col gap-2 w-full mt-2">
          <div className="flex justify-between items-center px-1">
            <span className="text-sm font-bold text-zinc-400">Progress</span>
            <span className="text-lg font-black text-sky-600">{progress || 0}%</span>
          </div>
          
          {/* Progress bar */}
          <div className="w-full bg-zinc-100 rounded-full h-2.5 overflow-hidden border border-zinc-50">
            <div
              className="h-full bg-gradient-to-r from-sky-500 to-indigo-600 transition-all duration-300 ease-out"
              style={{ width: `${progress || 0}%` }}
            />
          </div>
        </div>

        {/* Optional: message when upload is done */}
        {progress === 100 && (
          <div className="flex items-center gap-1.5 text-emerald-600 bg-emerald-50 px-3 py-1.5 rounded-full text-xs font-bold mt-2">
            <i className="fa-solid fa-circle-check"></i>
            Processing completed
          </div>
        )}
      </div>
    </div>
  );
};

export default UploadOverlay;